import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';

var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken'),
      'x-api-key': localStorage.getItem('Filename')
    })
  };
}

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  private messageSource = new BehaviorSubject('');
  Roledetails = this.messageSource.asObservable();
  tokenURL = this.environment.tokenURL;

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }

  private getHttpOptions() {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIEOrEdge) {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken') || '',
          'x-api-key': localStorage.getItem('Filename') || ''
        })
      };
    }
  }

  userprevilageapi(body): Observable<any> {
    let fileName = localStorage.getItem('Filename')
    const httpOptions = this.getHttpOptions();
    // Corrected property name NewUrl -> NewURL to match environment.ts exported object
    let API_URL = this.environment.NewURL + '/getUserPreviliege/{proxy+}' + '?fileName=' + fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(map((response: any) => response), catchError(this.handleError))
  }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }



  getProcStatus(body): Observable<any> {
    const httpOptions = this.getHttpOptions();
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let API_URL = this.environment.BussinessppsvapiUrl + '/getProcStatus/{proxy+}'
    return this.http.post(API_URL, body, httpOptions)
      .pipe(map((response: any) => response), catchError(this.handleError))
  }

  truncTempRepProd(body): Observable<any> {
    const httpOptions = this.getHttpOptions();
    let API_URL = this.environment.BussinessppsvapiUrl + '/trucnTempRepProd/{proxy+}'
    return this.http.post(API_URL, body, httpOptions)
      .pipe(map((response: any) => response), catchError(this.handleError))
  }

  editProcProcessStatus(body): Observable<any> {
    const httpOptions = this.getHttpOptions();
    let API_URL = this.environment.BussinessppsvapiUrl + '/editProcProcessStatus/{proxy+}'
    return this.http.post(API_URL, body, httpOptions)
      .pipe(map((response: any) => response), catchError(this.handleError))

  }

  async getTokens(tokenBody) {
    const httpOptionsauth = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        'Pragma': 'no-cache',
      })
    };
    return await this.http.post(this.tokenURL, tokenBody, httpOptionsauth)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError)).toPromise();
  }
  tokenUplddata(): Observable<any> {
    let fileName = localStorage.getItem('Filename')
    const httpOptions = this.getHttpOptions();
    return this.http.get(this.environment.NewURL + '/AssumeRole/{proxy+}' + '?fileName=' + fileName, httpOptions)
      .pipe(map((response: any) => response), catchError(this.handleError))
  }
  rmvUserDetails(): Observable<any> {
    let fileName = localStorage.getItem('Filename')
    const httpOptions = this.getHttpOptions();
    let API_URL = this.environment.rmvUserDetailsUrl + 'rmvUserDetails' + '?fileName=' + fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(map((response: any) => response), catchError(this.handleError))
  }
  UsersLoginDetails(): Observable<any> {
    let fileName = localStorage.getItem('Filename')
    const httpOptions = this.getHttpOptions();
    let API_URL = this.environment.Master_ActionInsertApiUrl + '/UsersLoginDetails/{proxy+}'
    return this.http.get(API_URL, httpOptions)
      .pipe(map((response: any) => response), catchError(this.handleError))
  }

  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  // ===================================== Exception Handler ===========================================
  private handleError(error: HttpErrorResponse) {
    var errorMsg = '';
    if (error.error instanceof ErrorEvent) {
      //A client-side or network error occurred. Handle it accordingly.
      errorMsg = `An error occurred: ${error.error.message}`;
    } else if (error.status == undefined) {
      errorMsg = 'Network error - reloading page';
      location.reload();
    } else {
      //The backend returned an unsuccessful response code.
      //The response body may contain clues as to what went wrong,
      errorMsg = `Backend returned code ${error.status}`;
    }
    //return an observable with a user-facing error message
    return throwError(errorMsg);
  }

  fileUploadUrl(filename): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName = localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
        })
      };
    }
    let API_URL = this.environment.searchGridUrl;
    return this.http.get(API_URL + filename, httpOptions)
      .pipe(
        map((response: any) => response),
        catchError(this.error)
      );
  }
  error(error: HttpErrorResponse) {
    let errorMessage: any = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = error.status;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

}
